// extracted by mini-css-extract-plugin
export var active = "ProductSearch-module--active--6c05f";
export var alternate = "ProductSearch-module--alternate--d96b5";
export var bounds = "ProductSearch-module--bounds--170fc";
export var button = "ProductSearch-module--button--58f0a";
export var copy = "ProductSearch-module--copy--647fa";
export var dark = "ProductSearch-module--dark--73ade";
export var icon = "ProductSearch-module--icon--81172";
export var input = "ProductSearch-module--input--37906";
export var link = "ProductSearch-module--link--f9a88";
export var list = "ProductSearch-module--list--09135";
export var results = "ProductSearch-module--results--7fb98";
export var search = "ProductSearch-module--search--fe292";
export var searchArea = "ProductSearch-module--search-area--59156";
export var searchBounds = "ProductSearch-module--search-bounds--a33cf";